<script>
  import ColorGetterMixinBase from 'components/Dashboards/Widgets/mixins/ColorGetterMixinBase';

  export default {
    name: 'ColorGetterNestedMixin',
    extends: ColorGetterMixinBase,
    methods: {
      getColorsListForEntities () {
        return this.metricSeries.map(item => this.colorGetter.getEntityColor(this.grouping, item.id));
      }
    }
  };
</script>
